/**
 * De lijst links van de chat: Socrates bovenaan, daaronder de gekozen
 * gesprekspartners. Aanklikken bepaalt aan wie het volgende bericht gaat.
 * In de reflectiefase staan de gesprekspartners er niet meer; dan praten
 * de leerlingen alleen nog met Socrates.
 */
import React from 'react';
import { kleur } from '../../../theme/tokens';
import { PersonaBeeld } from './GroepEnKlok';

export function ChatZijbalk({ apiUrl, discussieleider, personas, activePersona, onKies, reflectieFase }) {
  const rij = (p, omschrijving) => (
    <div key={p.id} onClick={() => onKies(p)} style={activePersona?.id === p.id ? styles.personaActief : styles.persona}>
      <span style={styles.avatar}><PersonaBeeld apiUrl={apiUrl} persona={p} grootte={36} /></span>
      <div>
        <div style={styles.naam}>{p.naam}</div>
        <div style={styles.omschrijving}>{omschrijving}</div>
      </div>
    </div>
  );

  return (
    <div style={styles.zijbalk}>
      <h3 style={styles.titel}>Discussieleider</h3>
      {/* Zijn profiel staat er bewust bij: Socrates kondigt in zijn
          openingsbericht aan dat je hem om hulp kunt vragen, en dan moet in
          de lijst te zien zijn dat hij daarvoor is. */}
      {discussieleider && rij(discussieleider, discussieleider.toelichting || 'Vraag mij om uitleg')}
      {!reflectieFase && (
        <>
          <h3 style={styles.titel}>Gesprekspartners</h3>
          {personas?.map(p => rij(p, p.toelichting))}
        </>
      )}
      {reflectieFase && (
        <div style={styles.reflectie}>
          <p>De discussietijd is om!</p>
          <p>Bespreek met Socrates welke argumenten je hebt gevonden.</p>
        </div>
      )}
    </div>
  );
}

const styles = {
  zijbalk: { background: kleur.vlak, padding: '16px', borderRight: `1px solid ${kleur.lijn}` },
  titel: { fontSize: '12px', color: kleur.stil, marginBottom: '12px', marginTop: '16px', textTransform: 'uppercase' },
  persona: { display: 'flex', gap: '12px', padding: '12px', borderRadius: '8px', cursor: 'pointer', marginBottom: '8px', background: 'white' },
  personaActief: { display: 'flex', gap: '12px', padding: '12px', borderRadius: '8px', cursor: 'pointer', marginBottom: '8px', background: kleur.accent, color: 'white' },
  avatar: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '36px', height: '36px', borderRadius: '50%', overflow: 'hidden', background: 'white', flexShrink: 0 },
  naam: { fontWeight: 'bold', fontSize: '14px' },
  omschrijving: { fontSize: '11px', opacity: 0.8 },
  reflectie: { background: 'white', padding: '16px', borderRadius: '8px', marginTop: '16px', textAlign: 'center', fontSize: '14px', color: 'black' },
};
